import axios from "axios";
import { takeLatest, put } from "redux-saga/effects";

import { API_BASE_URI } from "../ApiCall";
import { MaterialStartingBalanceActionTypes } from "./MaterialStartingBalance.type";

export function* fetchAllMaterialStartingBalances(action: any): any {
  try {
    let query = "";
    if (action.payload) {
      const keys = Object.keys(action.payload);
      query = keys.map((key) => `${key}=${action.payload[key]}`).join("&");
    }
    const response = yield axios.get(
      `${API_BASE_URI}/material-starting-balance?${query}`
    );
    yield put({
      type: MaterialStartingBalanceActionTypes.FETCH_ALL_MATERIAL_STARTING_BALANCE_SUCCESS,
      payload: response.data,
    });
  } catch (error) {
    yield put({
      type: MaterialStartingBalanceActionTypes.FETCH_ALL_MATERIAL_STARTING_BALANCE_FAILURE,
      payload: error,
    });
  }
}

export function* bulkUpsertMaterialStartingBalances(action: any): any {
  try {
    const response = yield axios.post(
      `${API_BASE_URI}/material-starting-balance/bulk-upsert`,
      { items: action.payload }
    );
    yield put({
      type: MaterialStartingBalanceActionTypes.BULK_UPSERT_MATERIAL_STARTING_BALANCE_SUCCESS,
      payload: response.data,
    });
  } catch (error) {
    yield put({
      type: MaterialStartingBalanceActionTypes.BULK_UPSERT_MATERIAL_STARTING_BALANCE_FAILURE,
      payload: error,
    });
  }
}

export function* watcherFetchAllMaterialStartingBalances() {
  yield takeLatest(
    MaterialStartingBalanceActionTypes.FETCH_ALL_MATERIAL_STARTING_BALANCE,
    fetchAllMaterialStartingBalances
  );
}

export function* watcherBulkUpsertMaterialStartingBalances() {
  yield takeLatest(
    MaterialStartingBalanceActionTypes.BULK_UPSERT_MATERIAL_STARTING_BALANCE,
    bulkUpsertMaterialStartingBalances
  );
}
